<mat-form-field appearance="outline" class="date-picker-container">
  <mat-label>{{ 'shared.datepicker.field_label' | translate }}</mat-label>
  <input
    matInput
    autocorrect="off"
    spellcheck="false"
    autocapitalize="none"
    spellcheck="false"
    [matDatepicker]="picker"
    [formControl]="dateControl"
    [placeholder]="'shared.datepicker.placeholder' | translate"
    [max]="maxDate"
    [min]="minDate"
    (focus)="onFocusIn()" />
  <ng-content></ng-content>
  <mat-datepicker-toggle
    matSuffix
    [for]="picker"
    class="mat-date-picker-icon"
    [disableRipple]="true"
    aria-hidden="true">
    <rd-shared-icon
      matDatepickerToggleIcon
      class="calendar"
      [iconSymbol]="'icon-calendar'"
      [iconTheme]="'primary'"></rd-shared-icon>
  </mat-datepicker-toggle>
</mat-form-field>

<mat-datepicker
  #picker
  startView="multi-year"
  (viewChanged)="currentCalendarView = $event"
  (closed)="currentCalendarView = null">
</mat-datepicker>
